<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import hero1 from '@/../images/banner1.jpg'
import hero2 from '@/../images/banner1.jpg'
import hero3 from '@/../images/banner1.jpg'

const slides = [
  { image: hero1, title: "Nurtured by Qur'an & Sunnah",       subtitle: "Cultivating scholars grounded in knowledge, taqwa, and noble character" },
  { image: hero2, title: "Tahfiz & Islamic Studies",           subtitle: "Safeguarding the Qur'an through memorization, understanding, and practice" },
  { image: hero3, title: "A Global Learning Community",        subtitle: "Building an Ummah through authentic Islamic knowledge" },
]

const currentSlide = ref(0)
let timer = null

const next = () => { currentSlide.value = (currentSlide.value + 1) % slides.length }
const prev = () => { currentSlide.value = (currentSlide.value - 1 + slides.length) % slides.length }
const stop = () => { clearInterval(timer); timer = null }
const start = () => { stop(); timer = setInterval(next, 6000) }

onMounted(start)
onBeforeUnmount(stop)
</script>

<template>
  <section
    class="relative h-[500px] overflow-hidden rounded-b-[2.5rem]"
    @mouseenter="stop"
    @mouseleave="start"
  >
    <div
      v-for="(slide, i) in slides"
      :key="i"
      class="absolute inset-0 transition-all duration-1000 ease-in-out"
      :class="i === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'"
    >
      <img :src="slide.image" class="w-full h-full object-cover" :alt="slide.title" />
      <div class="absolute inset-0 bg-black/50" />
      <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-6 text-white">
        <h2 class="text-4xl md:text-5xl font-bold mb-3 drop-shadow">{{ slide.title }}</h2>
        <p class="text-white/80 text-lg max-w-xl">{{ slide.subtitle }}</p>
      </div>
    </div>

    <!-- Dot indicators -->
    <div class="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-20">
      <button
        v-for="(_, i) in slides"
        :key="i"
        @click="currentSlide = i"
        class="w-2.5 h-2.5 rounded-full transition-all duration-300"
        :class="i === currentSlide ? 'bg-primary scale-125' : 'bg-white/50 hover:bg-white'"
        :aria-label="`Slide ${i + 1}`"
      />
    </div>
  </section>
</template>